import { render, staticRenderFns } from "./checkAccept.vue?vue&type=template&id=122a6f0c&scoped=true&"
import script from "./checkAccept.vue?vue&type=script&lang=js&"
export * from "./checkAccept.vue?vue&type=script&lang=js&"
import style0 from "./checkAccept.vue?vue&type=style&index=0&id=122a6f0c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122a6f0c",
  null
  
)

export default component.exports